<div class="container mx-auto pb-16">
  @if (isLoading()) {
    <aw-loading-animation></aw-loading-animation>
  } @else {
    @for (section of sections(); track section) {
      @let sectionIndex = $index;
      <div
        class="py-6 text-2xl font-semibold"
        [ngStyle]="{
          color: corporateDesign.fontColor(),
        }"
        [attr.data-testid]="
          'custom-tile-section-headline-' | appendTestId: sectionIndex
        ">
        {{
          section.texts
            | filterTexts: ERelationType.title : EEntityType.customTileSection
            | language
        }}
      </div>
      <div
        class="grid grid-cols-1 gap-4 md:grid-cols-2"
        [attr.data-testid]="'custom-tile-section' | appendTestId: sectionIndex">
        @for (tile of section.tiles; track tile) {
          @let tileIndex = $index;
          <div
            [attr.data-testid]="
              'custom-tile-' + sectionIndex | appendTestId: tileIndex
            "
            class="overflow-hidden"
            [ngStyle]="{
              borderRadius: corporateDesign.borderRadius(),
              background: corporateDesign.primaryColor() + '33',
            }">
            @if (tile.accessibleImage?.image) {
              <div
                [attr.data-testid]="
                  'custom-tile-image-container-' + sectionIndex
                    | appendTestId: tileIndex
                "
                class="flex h-72 flex-row items-center justify-center overflow-hidden">
                <img
                  [attr.data-testid]="
                    'custom-tile-image-' + sectionIndex
                      | appendTestId: tileIndex
                  "
                  class="min-h-full w-full"
                  [src]="
                    imageStore.getImagePath(tile.accessibleImage!.image!.id)
                  "
                  [alt]="
                    tile.accessibleImage?.imageAlts || []
                      | filterTexts
                        : ERelationType.imageAlt
                        : EEntityType.customTile
                      | language
                  " />
              </div>
            }

            <div
              class="h-full p-6"
              [attr.data-testid]="
                'custom-tile-bottom-' + sectionIndex | appendTestId: tileIndex
              "
              [ngStyle]="{
                background: corporateDesign.primaryColor(),
                color: corporateDesign.primaryFontColor(),
              }">
              <div
                class="pb-4 text-xl font-semibold"
                [attr.data-testid]="
                  'custom-tile-title-' + sectionIndex | appendTestId: tileIndex
                "
                [innerHTML]="
                  tile.texts
                    | filterTexts: ERelationType.title : EEntityType.customTile
                    | language
                "></div>
              <quill-view
                class="pb-4"
                format="json"
                [content]="
                  tile.texts
                    | filterTexts
                      : ERelationType.descriptionText
                      : EEntityType.customTile
                    | language
                "
                [attr.data-testid]="'direct-payment-description'"></quill-view>
              @if (tile.link) {
                <a
                  [href]="tile.link"
                  [attr.data-testid]="
                    'custom-tile-link-' + sectionIndex | appendTestId: tileIndex
                  "
                  class="flex cursor-pointer flex-row justify-end text-lg font-semibold">
                  <span
                    [attr.data-testid]="
                      'custom-tile-link-icon-' + sectionIndex
                        | appendTestId: tileIndex
                    "
                    class="material-symbols-rounded pr-2"
                    [ngStyle]="{
                      color: corporateDesign.linkIconColor(),
                    }"
                    >arrow_outward</span
                  ><span
                    [attr.data-testid]="
                      'custom-tile-link-text-' + sectionIndex
                        | appendTestId: tileIndex
                    "
                    >{{
                      tile.texts
                        | filterTexts
                          : ERelationType.iconText
                          : EEntityType.customTile
                        | language
                    }}</span
                  >
                </a>
              }
            </div>
          </div>
        }
      </div>
    }
  }
</div>
